import PropTypes from "prop-types";
import React, { useMemo } from "react";
import { SharedLineItemsTable, createHiddenGroupingColumns } from "./SharedLineItemsTable";
import { createBaseColumns } from "./sharedTableColumns";
import { createBaseDataRow, useLineItemsTableHandlers } from "./useLineItemsTableHandlers";

const SubcontractLineItemsTable = ({
  rows,
  onRowsChange,
  onFormDataChange,
  dropdownOptions,
  getDisplayText,
}) => {
  const defaultRowFields = {
    changeEvent: "",
    budgetCodeId: "",
    description: "",
    amount: "",
    billed: "",
    remaining: "",
  };

  const { handleEdit, handleAddRow, handleRemoveRow } = useLineItemsTableHandlers(
    rows,
    onRowsChange,
    onFormDataChange,
    defaultRowFields
  );

  const data = useMemo(
    () => rows.map((row, idx) => createBaseDataRow(row, idx, dropdownOptions, getDisplayText)),
    [rows, dropdownOptions, getDisplayText]
  );

  const columns = useMemo(() => {
    const visibleColumns = createBaseColumns(
      handleEdit,
      handleRemoveRow,
      dropdownOptions,
      getDisplayText
    );
    const hiddenGroupingCols = createHiddenGroupingColumns();
    return [...visibleColumns, ...hiddenGroupingCols];
  }, [handleEdit, dropdownOptions, getDisplayText, handleRemoveRow]);

  return <SharedLineItemsTable columns={columns} data={data} onAddRow={handleAddRow} />;
};

SubcontractLineItemsTable.propTypes = {
  rows: PropTypes.array.isRequired,
  onRowsChange: PropTypes.func.isRequired,
  onFormDataChange: PropTypes.func.isRequired,
  dropdownOptions: PropTypes.object.isRequired,
  getDisplayText: PropTypes.func.isRequired,
};

export default SubcontractLineItemsTable;
